import { get, findIndex, find } from 'lodash'

export default function (data, level) {
  if (!data) {
    return 0
  }

  const awards = get(data, 'awards', [])

  const activeAward = find(awards, award => {
    return award.awardLevel.value === level
      && award.awardState.value !== 'CEREMONY'
      && award.awardState.value !== 'COMPLETE'
      && award.awardState.value !== 'INACTIVE'
  })

  if (!activeAward) {
    return 0
  }

  return findIndex(awards, award => award.id === activeAward.id)
}
